/* eslint-disable react/prop-types */
/* eslint-disable max-lines-per-function */
import { Dropdown, Icon, Menu } from 'antd';
import React from 'react';
import { AdStatus } from '../../../models';
import styles from './adMoreMenu.scss';

const triggerOption: any = ['click'];
const menuKey = {
  edit: '1',
  deactivate: '2',
  sold: '3',
  delete: '4',
  active: '5',
};

const AdMoreMenu = ({ adActions, ad, onDropwdownContainerClick }) => {
  const handleMoreMenuClick = (menu: any) => {
    switch (menu.key) {
      case menuKey.edit:
        adActions.onEdit();
        break;

      case menuKey.delete:
        adActions.onDelete();
        break;

      case menuKey.active:
        adActions.onActive();
        break;

      case menuKey.deactivate:
        adActions.onPaused();
        break;

      case menuKey.sold:
        adActions.onSold();
        break;

      default:
        break;
    }
  };

  const activeMenu = (
    <Menu onClick={handleMoreMenuClick}>
      <Menu.Item className={styles.menuItem} key={menuKey.edit}>
        {"Uredi"}
      </Menu.Item>
      <Menu.Item className={styles.menuItem} key={menuKey.deactivate}>
        {"Pauziraj"}
      </Menu.Item>
      <Menu.Item className={styles.menuItem} key={menuKey.sold}>
        {"Prodano"}
      </Menu.Item>
      <Menu.Item className={styles.menuItem} key={menuKey.delete}>
        {"Obriši"}
      </Menu.Item>
    </Menu>
  );

  const pausedMenu = (
    <Menu onClick={handleMoreMenuClick}>
      <Menu.Item className={styles.menuItem} key={menuKey.edit}>
        {"Uredi"}
      </Menu.Item>
      <Menu.Item className={styles.menuItem} key={menuKey.active}>
        {"Aktiviraj"}
      </Menu.Item>
      <Menu.Item className={styles.menuItem} key={menuKey.sold}>
        {"Prodano"}
      </Menu.Item>
      <Menu.Item className={styles.menuItem} key={menuKey.delete}>
        {"Obriši"}
      </Menu.Item>
    </Menu>
  );

  const soldMenu = (
    <Menu onClick={handleMoreMenuClick}>
      <Menu.Item className={styles.menuItem} key={menuKey.active}>
        {"Reaktiviraj"}
      </Menu.Item>
      <Menu.Item className={styles.menuItem} key={menuKey.delete}>
        {"Obriši"}
      </Menu.Item>
    </Menu>
  );

  const createMoreMenu = () => {
    switch (ad.status) {
      case AdStatus.active:
        return activeMenu;

      case AdStatus.paused:
        return pausedMenu;

      case AdStatus.sold:
        return soldMenu;

      default:
        return null;
    }
  };

  return (
    <span role="button" tabIndex={0} onClick={onDropwdownContainerClick}>
      <Dropdown
        trigger={triggerOption}
        overlay={createMoreMenu()}
        className={styles.manageButton}
      >
        <Icon type="ellipsis" />
      </Dropdown>
    </span>
  );
};

export default AdMoreMenu;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdMoreMenu/AdMoreMenu.tsx